import { api } from './api';
import { Task, TaskPriority, TaskStatus } from '../types';

export interface CreateTaskRequest {
  caseId: string;
  title: string;
  description?: string;
  dueDate?: string;
  priority?: TaskPriority;
}

export interface UpdateTaskRequest {
  title?: string;
  description?: string;
  dueDate?: string | null;
  priority?: TaskPriority;
  status?: TaskStatus;
}

export interface TaskListResponse {
  tasks: Task[];
  count: number;
  pendingCount: number;
  overdueCount: number;
}

export const tasksApi = {
  list: async (caseId?: string, status?: TaskStatus): Promise<TaskListResponse> => {
    const params = new URLSearchParams();
    if (caseId) params.append('caseId', caseId);
    if (status) params.append('status', status);
    const queryString = params.toString();
    return api.get<TaskListResponse>(`/tasks${queryString ? `?${queryString}` : ''}`);
  },

  get: async (id: string): Promise<Task> => {
    return api.get<Task>(`/tasks/${id}`);
  },

  create: async (data: CreateTaskRequest): Promise<Task> => {
    return api.post<Task>('/tasks', data);
  },

  update: async (id: string, data: UpdateTaskRequest): Promise<Task> => {
    return api.put<Task>(`/tasks/${id}`, data);
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/tasks/${id}`);
  },
};
